//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from "jquery";
import { mapState } from "vuex";
// import * as MenuLayout from '~/components/menu';
// import CountryDropdown from '~/components/menu/CountryDropdown';
// import MenuBar from '~/components/menu/MenuBar';
// import MenuMobile from '~/components/menu/MenuMobile';

import Header from "~/content/data/header.json";
export default {
    name: "PageHeader",
    components: {
        // ...MenuLayout,
        // CountryDropdown
        // MenuBar,
        // MenuMobile
    },
    data() {
        return {
            active: null,
            sticky: false,
            open: false,
            allowNavOpen: { top: 0, left: 0, bottom: 0, right: 0 },
        };
    },
    computed: {
        ...mapState({
            page: (state) => state.pages.page,
        }),
        header: () => Header,
        theme() {
            if (this.page && this.page.header) return "navbar-" + (this.page.header.theme || "dark");
            return "navbar-dark";
        },
        _headerLogo() {
            //   if (this.page && this.page.header?.theme === "dark" && !this.page.sticky)
            //     return require("~/assets/images/burst-logo-white.svg");
            return require("~/static/uploads/burst-conversr-kudo.svg");
        },
        country() {
            if (this.page.region === "United States") {
                return "us";
            }

            return "au";
        },
    },
    methods: {
        _checkIfBounds(position, bounds) {
            return position.x <= bounds.right && position.x >= bounds.left && position.y >= bounds.top && position.y <= bounds.bottom;
        },
        _openNaV() {
            this.open = true;
            $("body").addClass("nav--open");
        },
        _navClose(event) {
            if (event) {
                if (this._checkIfBounds({ x: event.clientX, y: event.clientY }, this.allowNavOpen)) return;
            }
            this.open = false;
            this._setActiveHover(null);
            $("body").removeClass("nav--open");
            $("body").removeClass("nav-mobile--open");
            $("body .nav-item.hover").removeClass("hover");
        },
        _setActiveHover(m) {
            this.$set(this, "active", m);
            this.$forceUpdate();
        },
        _toggleNavMobile() {
            $("body").toggleClass("nav-mobile--open");
        },
    },
    created() {
        if (process.browser) {
            const self = this;
            $(function () {
                $(window).scroll(function () {
                    if (self.open) {
                        self._navClose();
                    }
                });

                $("body").on("click", '[aria-current="page"]', function (event) {
                    event.preventDefault();

                    self._navClose();
                    window.location.assign($(this).attr("href"));
                });

                // $('[href="#live-chat"]').click(function (event) {
                //   event.preventDefault();
                //   const chatButton = document.querySelector(".helpButtonEnabled");

                //   if (chatButton) {
                //     chatButton.click();
                //   } else {
                //     window.location.assign("https://help.burstsms.com/s/submit-ticket");
                //   }

                //   if (self.open) {
                //     self._navClose();
                //   }
                // });
            });
        }

        this.$router.beforeEach((to, from, next) => {
            if (to.name !== "slug") {
                window.location.assign(to.path.replace("/http", "http"));
                next(false);
            } else {
                this._navClose();
                next();
            }
        });
    },
};
